export function formatRupiah(number) {
  if (typeof number !== "number") {
    return number; // if not a number, return as is
  }
  return "Rp. " + number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatToIDR(number) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  })
    .format(number)
    .replace(/\D00(?=\D*$)/, ""); // remove decimals
}
